const ACCESS_TOKEN_KEY = "agt_access_token";

/**
 * Saves the access token to localStorage.
 * @param token The access token string.
 */
export const saveAccessToken = (token: string): void => {
  localStorage.setItem(ACCESS_TOKEN_KEY, token);
};

/**
 * Retrieves the access token from localStorage.
 * @returns The access token string, or null if not found.
 */
export const getAccessToken = (): string | null => {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
};

/**
 * Removes the access token from localStorage.
 */
export const removeAccessToken = (): void => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
};

/**
 * Checks if a user is authenticated based on the presence of an access token.
 * @returns True if an access token exists, false otherwise.
 */
export const isAuthenticated = (): boolean => {
  return !!getAccessToken();
};
